import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';
import {BehaviorSubject, Observable, of} from 'rxjs';

// Models
import { ApiResponse } from '../shared/models/api-response.model';
import { ErrorTriggers } from './models/error-triggers.model';
import { PaymentTerm } from './models/payment-term.model';
import {SaleGroupItem} from './models/sale-group-items.model';
import {PaymentPlanPreview} from './models/payment-plan-preview.model';

import { PaymentTerms } from './models/payment-terms.model';
import { SinglePaymentTerms } from './models/single-payment-term.model';
import { AmountFormatterService } from '../sale-item/amount-formatter.service';

@Injectable({
  providedIn: 'root'
})
export class MultiPaymentTermsService {
  errorTriggers: ErrorTriggers = {};
  selectedPaymentTermSubject = new BehaviorSubject<any>([]);
  customDatesSubject = new BehaviorSubject<any>({});
  upfrontPaymentAmountSubject = new BehaviorSubject<any>({});
  triggerPaymentTermErrorSubject = new BehaviorSubject<any>({});
  customDatesControl = new BehaviorSubject<any>('');
  previewData = new BehaviorSubject<PaymentPlanPreview>({customer_service_fee: '', initial_payment_amount: '', payments: []});
  emitOutput = new BehaviorSubject<any>(false);
  $paymentTerm = this.selectedPaymentTermSubject.asObservable();
  $customDates = this.customDatesSubject.asObservable();
  $upfrontPayment = this.upfrontPaymentAmountSubject.asObservable();
  $triggerError = this.triggerPaymentTermErrorSubject.asObservable();
  constructor(public httpClient: HttpClient,
              private amountFormatter: AmountFormatterService) { }

  protected static getIndexUri(): string {
    return environment.apiUrl + 'payment_terms';
  }

  protected static getPreviewUri(): string {
    return environment.apiUrl + 'payment_plans/new';
  }

  private static getOptions(params?: object): object {
    return {
      params: params,
      withCredentials: true,
      headers: {
        Accept: 'application/json'
      }
    };
  }

  getPaymentTerms(orgId: string): Observable<ApiResponse<PaymentTerm[]>> {
    const params = { organization_id: orgId, 'order[name]': 'asc' };
    return this.httpClient.get<ApiResponse<PaymentTerm[]>>(
      MultiPaymentTermsService.getIndexUri(),
      MultiPaymentTermsService.getOptions(params)
    );
  }

  getPlanPreview(
    paymentTermId: number,
    saleGroupItems?: SaleGroupItem[],
    initialAmount?: number,
    totalAmount?: string
  ): Observable<ApiResponse<PaymentPlanPreview>> {
    const params = { payment_term_id: paymentTermId };
    if (saleGroupItems) {
      params['invoice_group_items'] = JSON.stringify(saleGroupItems);
    } else {
      params['initial_amount'] = initialAmount;
      params['total_amount'] = totalAmount;
    }
    return this.httpClient.get<ApiResponse<PaymentPlanPreview>>(
      MultiPaymentTermsService.getPreviewUri(),
      MultiPaymentTermsService.getOptions(params)
    );
  }

  public updateErrorTriggers(triggers: ErrorTriggers): void {
    Object.keys(triggers).forEach((triggerKey) => {
      this.errorTriggers[triggerKey] = triggers[triggerKey];
    });
    this.triggerPaymentTermErrorSubject.next(this.errorTriggers);
  }

  sanitizedAmount(amount: string): number {
    return this.amountFormatter.sanitizePrice(amount);
  }

  resetSubjects(): void {
    this.selectedPaymentTermSubject.next([]);
    this.customDatesControl.next('');
    this.customDatesSubject.next({});
    this.upfrontPaymentAmountSubject.next({});
    this.triggerPaymentTermErrorSubject.next({});
  }
}
